<mat-card appearance="outlined" class="h-100">
	<mat-card-title class="row d-flex justify-content-between">
		<p class="col">Agent rezerwacji</p>
		<button mat-icon-button [matMenuTriggerFor]="menu" class="fs-5">
			<i class="col text-end cursor-pointer fa fa-ellipsis-vertical"></i>
		</button>
		<mat-menu #menu>
			<button mat-menu-item (click)="goToSellerEdit()">
				<span>Zmień dane agenta</span>
			</button>
			<button mat-menu-item (click)="openDialog()">
				<span>Zmień agenta</span>
			</button>
		</mat-menu>
	</mat-card-title>
	<mat-card-subtitle
		><a
			class="link-dark seller_name text-overflow-ellipsis d-block"
			target="_blank"
			[matTooltip]="seller?.name"
			[href]="editUrl"
			>{{ seller?.name }}</a
		></mat-card-subtitle
	>
	<mat-card-content>
		<mat-table [dataSource]="matData">
			<ng-container matColumnDef="phone">
				<mat-header-cell *matHeaderCellDef outline> Numer telefonu </mat-header-cell>
				<mat-cell class="seller_phone" *matCellDef="let element">{{ element.phone ?? 'Brak' }}</mat-cell>
			</ng-container>
			<ng-container matColumnDef="email">
				<mat-header-cell *matHeaderCellDef outline> E-Mail </mat-header-cell>
				<mat-cell class="seller_email" *matCellDef="let element">{{ element.email ?? 'Brak' }}</mat-cell>
			</ng-container>
			<ng-container matColumnDef="city">
				<mat-header-cell *matHeaderCellDef outline> Miasto </mat-header-cell>
				<mat-cell class="seller_city" *matCellDef="let element">{{ element.city ?? 'Brak' }}</mat-cell>
			</ng-container>
			<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
			<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
		</mat-table>
	</mat-card-content>
</mat-card>
